import * as types from '../mutation-types'
import difference from 'lodash/difference'
import union from 'lodash/union'
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'
import pick from 'lodash/pick'
import {pMap} from '../../utils'
import axios from 'axios'
import {base64ArrayBuffer} from '../../base64'

const axiosExternal = axios.create({baseURL: '', headers: {common: []}})
delete axiosExternal.defaults.headers.common['Authorization']

const state = {
  audioFiles: [],
  audioFilesAdded: [],
  audioFilesRemoved: [],
  loadingAudioFiles: false,
  errorAudioFiles: null
}

const getters = {
  getAudioFiles (state) {
    return difference(union(state.audioFiles, state.audioFilesAdded), state.audioFilesRemoved)
  },
  getAudioById (state, getters) {
    return function (id) {
      return getters.getAudioFiles.find(item => item.uuid === id) || {}
    }
  }
}

const actions = {
  saveAudioFiles ({ commit, state, rootState }) {
    const orgId = get(rootState, 'authentication.currentOrgId')
    const url = `/orgs/${orgId}/files`
    const files = state.audioFilesAdded.map((f) => Object.assign(pick(f, ['uuid', 'fileType', 'friendlyName', 'uri', 'fileName']), {permanent: true}))
    const addPromise = pMap(files, (f) => axios.post(`${url}`, f), {concurrency: 5})
    const removePromise = pMap(state.audioFilesRemoved, (f) => axios.delete(`${url}/${f}`), {concurrency: 5})
    return Promise.all([addPromise, removePromise])
  },
  getAudiosFromDuplicate ({commit, state, rootState}, {audios}) {
    commit(types.SET_AUDIO_FILES_LOADING, true)
    const transform = (r) => `data:${r.headers['content-type']};base64,${base64ArrayBuffer(r.data)}`
    const orgId = get(rootState, 'authentication.currentOrgId')
    pMap(audios, audio => Promise.all([audio, axios.get(`/orgs/${orgId}/files/` + audio.uuid)]).then((tuple) => {
      let [snd, {data: audio}] = tuple
      return axiosExternal.get(audio.url, {responseType: 'arraybuffer'}).then(r => {
        return Object.assign({}, audio, {uuid: snd.newUuid}, {uri: transform(r)})
      })
    }), {concurrency: 5})
    .then((audios) => {
      commit(types.SET_AUDIO_FILES_ADDED, audios)
    })
    .catch((error) => {
      commit(types.SET_AUDIO_FILES_ERROR, { response: error.name, message: error.message })
    })
    .then(() => {
      commit(types.SET_AUDIO_FILES_LOADING, false)
    })
  },
  downloadAudioFiles ({ commit, state, rootState }) {
    commit(types.SET_AUDIO_FILES_LOADING, true)
    const orgId = get(rootState, 'authentication.currentOrgId')
    const campaignId = get(rootState, 'campaign.current.id')
    if (!campaignId) {
      commit(types.RESET_AUDIO_FILES)
      commit(types.SET_AUDIO_FILES_LOADING, false)
      return
    }
    let url = `/orgs/${orgId}/files?campaignId=${campaignId}`
    axios.get(url)
      .then(
        (response) => {
          Promise.all(response.data.map(f => axios.get(`/orgs/${orgId}/files/` + f.uuid))).then(
          (res) => {
            commit(types.SET_AUDIO_FILES, {data: res.data})
            commit(types.SET_AUDIO_FILES_LOADING, false)
          })
        }
      )
    .catch(error => {
      commit(types.SET_AUDIO_FILES_LOADING, false)
      commit(types.SET_AUDIO_FILES_ERROR, { response: error.name, message: error.message })
    })
  },
  addAudioFiles ({commit, state}, audio) {
    commit(types.ADD_AUDIO_FILE, { audio })
  },
  removeAudioFiles ({commit, state}, audio) {
    commit(types.REMOVE_AUDIO_FILE, { audio })
  }
}

const mutations = {
  [types.ADD_AUDIO_FILE] (state, { audio }) {
    state.audioFilesAdded.push(cloneDeep(audio))
  },
  [types.REMOVE_AUDIO_FILE] (state, { audio }) {
    if (audio.id) {
      state.audioFilesRemoved.push(audio)
    } else {
      const index = state.audioFilesAdded.findIndex((v) => v.uuid === audio.uuid)
      if (index !== -1) {
        state.audioFilesAdded.splice(index, 1)
      }
    }
  },
  [types.SET_AUDIO_FILES] (state, audios) {
    state.audioFiles = cloneDeep(audios)
  },
  [types.SET_AUDIO_FILES_ADDED] (state, audios) {
    state.audioFilesAdded = cloneDeep(audios)
  },
  [types.RESET_AUDIO_FILES] (state) {
    state.audioFilesAdded = []
  },
  [types.SET_AUDIO_FILES_LOADING] (state, value) {
    state.loadingAudioFiles = value
  },
  [types.SET_AUDIO_FILES_ERROR] (state, value) {
    state.errorAudioFiles = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/audiofile.js